module.exports = __webpack_public_path__ + "static/img/jcb.4636630d.png";